import React, { Fragment, useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { api } from '../../services'
import QuestHeader from './components/QuestHeader'
import { useTranslation } from 'react-i18next'
import { Spin, Table, Button, Modal, Tag, Icon, Pagination, Typography, Row, Col, Form, Input, InputNumber, message, Tooltip, Select } from 'antd'
import history from '../../history'
import LocationPickerModal from './components/LocationPickerModal.jsx'
import './quest.scss'
const { Title, Text } = Typography
const { Option } = Select

const ListQuest = ({ user }) => {
    const { t } = useTranslation()
    const { active_organization_id, id: user_id } = user?.info
    const [isFetching, setIsFetching] = useState(false)
    const [hunts, setHunts] = useState([])
    const [total, setTotal] = useState(0)
    const [query, setQuery] = useState({
        org_id: String(active_organization_id),
        user_id: String(user_id),
        limit: 100,
        offset: 0
    })

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedHunt, setSelectedHunt] = useState(null)
    const [allLocations, setAllLocations] = useState([])
    const [selectedLocationId, setSelectedLocationId] = useState(null)
    const [isFetchingStops, setIsFetchingStops] = useState(false)
    const [activeIndex, setActiveIndex] = useState(null)
    const [isLocationModalVisible, setIsLocationModalVisible] = useState(false)
    const [isLocationDataModalVisible, setIsLocationDataModalVisible] = useState(false)
    const [isGenerating, setIsGenerating] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [generatedData, setGeneratedData] = useState(null)
    const [locationForm, setLocationForm] = useState({
        location: '',
        radius: null,
        groups: []
    })
    const [users, setUsers] = useState([])
    // const { list: { rows: orgList = [] } } = useSelector(state => state.organizations)
    // const { groups: groupList = [] } = orgList.find(org => org.id === active_organization_id) || {}

    useEffect(() => {
        getQuestContent()
    }, [query])

    const ageGroupOptions = [
        { label: 'Preschool (3-5)', value: '3-5' },
        { label: 'Elementary (6-10)', value: '6-10' },
        { label: 'Middle School (11-13)', value: '11-13' },
        { label: 'High School (14-18)', value: '14-18' },
        { label: 'Adults (18+)', value: '18+' }
    ]

    const getQuestContent = async () => {
        setIsFetching(true)
        try {
            const res = await api.quest.getQuestContent(query)
            if (res?.data) {
                const huntsWithKeys = (res.data.hunts || []).map((hunt, index) => ({
                    ...hunt,
                    key: `hunt-${index}-${hunt.id || hunt.hunt_id || Date.now()}`
                }))
                setHunts(huntsWithKeys)
                const apiCount = Number(res.data.count || 0)
                setTotal(Math.max(apiCount, huntsWithKeys.length))
            }
        } catch (error) {
            console.error('Error fetching quests:', error)
        } finally {
            setIsFetching(false)
        }
    }

    const handleView = async (hunt) => {
        setIsFetchingStops(true)
        setAllLocations([])
        setSelectedLocationId(null)
        setSelectedHunt(hunt)
        setIsModalVisible(true)
        setActiveIndex(null)

        try {
            const res = await api.quest.getSpecificQuest(hunt.hunt_id)
            if (res?.data?.locations?.length > 0) {
                const locations = res.data.locations
                setAllLocations(locations)
                setSelectedLocationId(locations[0].id || locations[0].location_id || 0)
            }
        } catch (error) {
            console.error('Error fetching locations:', error)
            // message.error('Failed to load quest locations')
        } finally {
            setIsFetchingStops(false)
        }
    }

    const handleSelectLocation = (location) => {
        if (!location) return
        setSelectedLocationId(location.id || location.location_id || 0)
        setActiveIndex(null)
    }

    const getMergedHunt = () => {
        if (!selectedHunt) return null
        const activeLocation = allLocations.find(l => (l.id || l.location_id || 0) === selectedLocationId) ||
            (selectedLocationId === 0 && allLocations[0] ? allLocations[0] : null)

        if (!activeLocation) return selectedHunt

        const existingStops = selectedHunt.stops || []
        const aiStops = activeLocation.stops || []

        const mergedStops = existingStops.map((stop, index) => {
            const aiStop = aiStops.find(s => s.stop_number === (index + 1))
            return aiStop ? { ...stop, ...aiStop } : stop
        })

        return {
            ...selectedHunt,
            ...activeLocation,
            stops: mergedStops
        }
    }

    const mergedHunt = getMergedHunt()
    const togglePanel = (index) => {
        setActiveIndex(prev => (prev === index ? null : index))
    }

    const handlePageChange = (page, pageSize) => {
        setQuery(prev => ({
            ...prev,
            limit: pageSize,
            offset: (page - 1) * pageSize
        }))
    }

    const resetLocationModal = () => {
        setIsLocationModalVisible(false)
        setLocationForm({
            location: '',
            radius: null,
            groups: []
        })
    }

    const handleCloseMainModal = () => {
        setIsModalVisible(false)
    }

    const handleGenerateLocation = async () => {
        if (!locationForm?.location?.full) {
            message.error('Please enter a location')
            return
        }
        if (locationForm.radius > 5000) {
            message.error('Radius cannot exceed 5000 meters')
            return
        }
        if (!locationForm.groups[0]?.group_name) {
            message.error('Please input group name')
            return
        }
        if (!locationForm.groups[0]?.group_ids?.length < 0) {
            message.error('Please select at least one user')
            return
        }
        setIsGenerating(true)
        try {
            const payload = {
                treasure_hunt_id: selectedHunt.id || selectedHunt.hunt_id,
                location: locationForm.location?.full,
                coordinates: locationForm.location?.lat + ',' + locationForm.location?.lng,
                radius: locationForm.radius,
                groups: locationForm.groups,
            }
            const res = await api.quest.generateLocationAction(payload)
            console.log('test', res)
            if (res?.data) {
                const newData = res.data
                setGeneratedData(newData)

                // Add to variations list and select it
                setAllLocations(prev => [...prev, newData])
                setSelectedLocationId(newData.id || newData.location_id || Date.now())

                message.success('Location and stops generated successfully')
                resetLocationModal()
            }
        } catch (error) {
            console.error('Error generating location:', error)
            message.error('Failed to generate location')
        } finally {
            setIsGenerating(false)
        }
    }

    const columns = [
        {
            title: 'Quest Title',
            dataIndex: 'title',
            key: 'title',
            render: text => <span style={{ fontWeight: 600 }}>{text}</span>
        },
        {
            title: 'Age Group',
            dataIndex: 'age_group',
            key: 'age_group',
            render: age => {
                const option = ageGroupOptions.find(opt => opt.value === age)
                return <Tag color="blue">{option ? option.label : age}</Tag>
            }
        },
        {
            title: 'Total Stops',
            key: 'stops',
            render: (text, record) => (
                <Tag color="purple">{record.stops?.length || 0} Stops</Tag>
            )
        },
        {
            title: '',
            key: 'action',
            width: 150,
            align: 'right',
            render: (text, record) => (
                <Button type="primary" size="small" style={{ padding: '0 10px' }} onClick={() => handleView(record)}>
                    View Stops
                </Button>
            )
        }
    ]
    const getUserList = async () => {
        try {
            const res = await api.quest.getUserList({ org_id: active_organization_id, limit: 50 })
            if (res.data) {
                setUsers(res.data?.users || [])
            }
        } catch (error) {
            console.error('Error fetching users:', error)
        }
    }
    return (
        <Fragment>

            <section className="section" style={{ paddingBottom: '10rem' }}>
                <QuestHeader t={t} type={"List"} />
                <div style={{ marginTop: '2rem' }}>
                    <div style={{
                        background: '#fff',
                        padding: '24px 32px',
                        borderRadius: '8px',
                        marginBottom: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        borderBottom: '3px solid #1890ff',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div>
                            <Title level={2} style={{ margin: 0, color: '#262626' }}>Quest Management</Title>
                            <Text type="secondary" style={{ fontSize: '14px' }}>
                                View, monitor and manage all your generated quests
                            </Text>
                        </div>
                        <Button
                            type="primary"
                            icon="plus"
                            size="large"
                            className="rounded"
                            onClick={() => history.push('/quest-create?step=1')}
                        >
                            Create New Quest
                        </Button>
                    </div>

                    <Spin spinning={isFetching}>
                        <div className="form-body">
                            <Table
                                columns={columns}
                                dataSource={hunts}
                                pagination={false}
                            />
                            <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'flex-end' }}>
                                <Pagination
                                    current={(query.offset / query.limit) + 1}
                                    total={total}
                                    pageSize={query.limit}
                                    onChange={handlePageChange}
                                    onShowSizeChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </Spin>
                </div>
            </section>

            <Modal
                title={mergedHunt ? `${mergedHunt.title}` : 'Quest Stops'}
                visible={isModalVisible}
                onCancel={handleCloseMainModal}
                footer={[<Button key="close" className="rounded" onClick={handleCloseMainModal}>
                    Close
                </Button>
                ].filter(Boolean)}
                width={'75%'}
                centered
            >
                <Spin spinning={isFetchingStops}>
                    {mergedHunt && (
                        <div className="objectives-box">
                            <h4 className="corporate-label">
                                <Icon type="rocket" /> Quest Objectives
                            </h4>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <p className="objectives-text" style={{ flex: 1, marginRight: '20px' }}>{mergedHunt.objectives}</p>
                                <Button
                                    type="primary"
                                    icon="environment"
                                    className="rounded"
                                    onClick={() => {
                                        getUserList()
                                        setIsLocationModalVisible(true)
                                        setIsLocationDataModalVisible(true)
                                    }}
                                >
                                    {allLocations.length > 0 ? 'Add More Location' : 'Add Location'}
                                </Button>
                            </div>
                        </div>
                    )}

                    {allLocations.length > 0 && (
                        <div className="location-variations-section">
                            <h4 className="corporate-label">
                                <Icon type="environment" /> Location Variations
                            </h4>
                            <div className="variations-grid">
                                {allLocations.map((location, index) => {
                                    const locId = location.id || location.location_id || index;
                                    const isActive = selectedLocationId === locId;
                                    return (
                                        <div
                                            className={`location-variant-card ${isActive ? 'active' : ''}`}
                                            key={index}
                                            onClick={() => handleSelectLocation(location)}
                                        >
                                            <div className="variant-header">
                                                <Icon type="rocket" />
                                                <span>{location?.starting_location?.name || location?.starting_introduction?.name || `Variation ${index + 1}`}</span>
                                            </div>
                                            {/* <div className="variant-meta">
                                                <Fragment>
                                                    <div className="meta-item">
                                                        <Icon type="swap" />
                                                        {location?.total_walking_distance_meters}m
                                                    </div>
                                                    <div className="meta-item">
                                                        <Icon type="clock-circle" />
                                                        {location?.estimated_walking_time_minutes} mins
                                                    </div>
                                                </Fragment>
                                            </div> */}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {mergedHunt && (
                        <div className="accordion">
                            {(mergedHunt.stops || []).map((content, index) => (
                                <div className="accordion__item" key={index}>
                                    <div
                                        className={`accordion__header ${activeIndex === index ? 'active' : ''}`}
                                        onClick={() => togglePanel(index)}
                                    >
                                        <div className="accordion__title">
                                            <span className="accordion__step-num">#{content.number || index + 1}</span>
                                            {content.title}
                                            {content.objective && (
                                                <Tooltip title={content.objective} placement="top">
                                                    <Icon
                                                        type="info-circle"
                                                        style={{ marginLeft: 8, color: '#1890ff', cursor: 'help' }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div className="accordion__meta">
                                            <Tag style={{ backgroundColor: '#f0f5ff', color: '#1d39c4', border: '1px solid #adc6ff' }}>
                                                {content.points || 10} Points
                                            </Tag>
                                            &nbsp;
                                            <Icon type={activeIndex === index ? 'up' : 'down'} />
                                        </div>
                                    </div>

                                    <div className={`accordion__body ${activeIndex === index ? 'open' : ''}`}>
                                        <div className="accordion__content corporate-style">
                                            <div className="accordion__section">
                                                <h4 className="corporate-label">Mission Narrative</h4>
                                                <p className="corporate-text">{content.story}</p>
                                            </div>

                                            <div className="accordion__grid">
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Fun Fact</h4>
                                                    <div className="corporate-insight">
                                                        <Icon type="bulb" style={{ color: '#faad14', marginRight: 8 }} />
                                                        {content.fun_fact}
                                                    </div>
                                                </div>
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Open Ended Question</h4>
                                                    <p className="corporate-text-secondary">{content.quiz?.open_ended}</p>
                                                </div>
                                            </div>

                                            <div className="accordion__grid">
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Knowledge Check</h4>
                                                    <div className="quiz-box">
                                                        <div className="quiz-question">
                                                            <Icon type="question-circle" style={{ color: '#1890ff', marginRight: 8 }} />
                                                            {content.quiz?.multiple_choice?.question}
                                                        </div>
                                                        <ul className="quiz-options">
                                                            {content.quiz?.multiple_choice?.options?.map((opt, i) => (
                                                                <li key={i}>
                                                                    {opt}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                                {content.clue && (
                                                    <div className="accordion__section">
                                                        <h4 className="corporate-label">Mission Hints</h4>
                                                        {content.clue && (
                                                            <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                                                <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{content.clue.narrative_content}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="accordion__location_grid">
                                                {content.location && (
                                                    <div className="accordion__section">
                                                        <h4 className="corporate-label">Location Hints</h4>
                                                        {content.location && (
                                                            <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                                                <Icon type="environment" style={{ color: '#1890ff', marginRight: 8 }} />
                                                                <strong>{content.location.name}</strong>
                                                                <div style={{ marginLeft: 24, fontSize: '12px', color: '#8c8c8c' }}>{content.location.address}</div>
                                                            </div>
                                                        )}
                                                        <div className="corporate-hints">
                                                            {content.clue?.mission_context && (
                                                                <div className="hint-item">
                                                                    <span className="hint-label">Mission Context:</span>
                                                                    <span className="hint-value">{content.clue.mission_context}</span>
                                                                </div>
                                                            )}
                                                            {content.clue?.location_clues && (
                                                                <div className="hint-item">
                                                                    <span className="hint-label">Location Clues:</span>
                                                                    <div className="tag-group" style={{ display: 'block' }}>
                                                                        {content.clue.location_clues.map((c, i) => (
                                                                            <div key={i} className="corporate-text-secondary" style={{ marginBottom: 4 }}>• {c}</div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {content.clue?.confirmation && (
                                                                <div className="hint-item">
                                                                    <span className="hint-label">Confirmation:</span>
                                                                    <span className="hint-value" style={{ color: '#52c41a', fontWeight: 600 }}>{content.clue.confirmation}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </Spin>
            </Modal>

            <Modal
                title="Generate Location & Stops"
                visible={isLocationModalVisible}
                onCancel={resetLocationModal}
                footer={[
                    <Button key="cancel" className="rounded" onClick={resetLocationModal}>
                        Cancel
                    </Button>,
                    <Button
                        key="generate"
                        type="primary"
                        className="rounded"
                        loading={isGenerating}
                        onClick={handleGenerateLocation}
                    >
                        Generate
                    </Button>
                ]}
                width={600}
                centered
                maskClosable={false}
            >
                <Form layout="vertical">
                    <Form.Item label="Starting Location" required>
                        <LocationPickerModal
                            onLocationSelect={(location) => {
                                console.log("test", location)
                                setLocationForm({ ...locationForm, location })
                                setIsLocationDataModalVisible(false)
                            }}
                            onClose={() => {
                                if (locationForm.location) {
                                    setIsLocationDataModalVisible(false)
                                } else {
                                    setIsLocationDataModalVisible(false)
                                    resetLocationModal()
                                }
                            }}
                            open={isLocationDataModalVisible}
                            value={locationForm.location}
                        />
                        <Input
                            onClick={() => !isGenerating && setIsLocationDataModalVisible(true)}
                            placeholder="e.g. dhl group, Charles-de-Gaulle-Straße 20, 53113 Bonn"
                            value={locationForm.location ? (locationForm.location?.town) : ''}
                            readOnly
                        />
                    </Form.Item>
                    <Form.Item label="Radius (meters)" required>
                        <InputNumber
                            placeholder="e.g. 1000"
                            style={{ width: '100%' }}
                            min={100}
                            max={5000}
                            value={locationForm.radius}
                            onChange={(val) => setLocationForm({ ...locationForm, radius: val })}
                        />
                    </Form.Item>
                    <Form.Item label="Group Name" required>
                        <Input
                            placeholder="e.g. dhl group, Charles-de-Gaulle-Straße 20, 53113 Bonn"
                            value={locationForm.groups[0]?.group_name || ''}
                            onChange={(e) => setLocationForm({ ...locationForm, groups: [{ ...locationForm.groups[0], created_by: user_id, group_name: e.target.value }] })}
                        />
                    </Form.Item>
                    <Form.Item label="Select Users" required>
                        <Select
                            mode="multiple"
                            placeholder="Select Users"
                            onChange={(value) => setLocationForm({ ...locationForm, groups: [{ ...locationForm.groups[0], created_by: user_id, user_ids: value }] })}
                            value={locationForm.groups[0]?.user_ids}
                        >
                            {users.map(user => (
                                <Option key={user.id} value={user.id}>
                                    {user.first_name + ' ' + user.last_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>

                {generatedData && (
                    <div style={{ marginTop: '20px', padding: '15px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '4px' }}>
                        <h4 style={{ color: '#52c41a', marginBottom: '10px' }}>
                            <Icon type="check-circle" /> Generation Summary
                        </h4>
                        <Row gutter={[16, 8]}>
                            <Col span={12}>
                                <strong>Stops:</strong> {generatedData.stops?.length || 0}
                            </Col>
                            <Col span={12}>
                                <strong>Distance:</strong> {generatedData.route_summary?.total_walking_distance_meters}m
                            </Col>
                            <Col span={12}>
                                <strong>Time:</strong> ~{generatedData.route_summary?.estimated_walking_time_minutes} mins
                            </Col>
                            <Col span={24} style={{ marginTop: '8px' }}>
                                <strong>Starting At:</strong> {generatedData.starting_location?.name}
                            </Col>
                        </Row>
                    </div>
                )}
            </Modal>
        </Fragment >
    )
}

const mapStateToProps = state => ({
    user: state.user
})

export default connect(
    mapStateToProps,
)(ListQuest)

